import React from "react";
import PropTypes from "prop-types";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { tomorrow } from "react-syntax-highlighter/dist/esm/styles/prism";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(2),
  },
}));

function CodeBlock(props: any) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <SyntaxHighlighter language={props.language} style={tomorrow}>
        {props.value}
      </SyntaxHighlighter>
    </div>
  );
}

CodeBlock.defaultProps = {
  language: "",
};

CodeBlock.propTypes = {
  value: PropTypes.string.isRequired,
  language: PropTypes.string,
};

export default CodeBlock;
